import React from 'react';
import { useNavigate } from 'react-router-dom';
import DigitalDisplay from '../components/DigitalDisplay';
import './Roadmap.css';

const Roadmap = () => {
  const navigate = useNavigate();

  const roadmapData = [
    {
      year: 2025,
      quarters: {
        Q1: [
          'Launch $1 Odyssey Gamified Platform MVP with staking and basic mechanics.',
          'Expand Community engagement with interactive promotional events.',
          'Prepare the first Character Classes for exclusive $1 Holder previews.',
        ],
        Q2: [
          'Release inaugural NFT collections tied to gameplay and staking rewards.',
          'Introduce leaderboard and reputation systems with incentives.',
          'Optimize platform for mobile accessibility.',
        ],
        Q3: [
          'Implement advanced burning mechanisms to fortify tokenomics.',
          'Unveil beta in-game campaigns featuring Community-driven missions.',
          'Collaborate with Solana projects for co-branded initiatives.',
        ],
        Q4: [
          'Launch full gamified ecosystem with NFT-driven economy.',
          'Introduce Community governance and voting mechanisms.',
          'Strengthen partnerships with DeFi platforms to amplify utility.',
        ],
      },
    },
    {
      year: 2026,
      quarters: {
        Q1: [
          'Establish DAO framework for decentralized Community decision-making.',
          'Expand in-game universe with new story arcs and immersive quests.',
          'Enhance staking rewards with exclusive, utility-focused NFTs.',
        ],
        Q2: [
          'Advance cross-chain compatibility research to broaden horizons.',
          'Drop limited-edition NFTs for contributors and key milestones.',
          'Host exclusive events to deepen Community bonds.',
        ],
        Q3: [
          'Integrate real-world applications for token utility.',
          'Evolve gamification to include co-op multiplayer features.',
          'Revamp UX/UI to set new standards for seamless navigation.',
          'Set course, through our DAO, to build out a $Trillion (USD) Market Cap.',
        ],
        Q4: [
          'Achieve cross-chain functionality for a multi-network experience.',
          'Host the inaugural $1 Odyssey Gaming Tournament, setting the stage for competitive play.',
          'Refine the Roadmap based on collaborative feedback and insights.',
          'Begin talks with Countries, establishing plan to utilize $1 to eliminate their debt.',
        ],
      },
    },
  ];

  return (
    <div className="page-container">
      <DigitalDisplay>
        <div className="roadmap-header">
          <h1>Roadmap</h1>
        </div>
        <div className="roadmap-content">
          {roadmapData.map((yearData) => (
            <div key={yearData.year} className="roadmap-year">
              <h2>{yearData.year}</h2>
              {Object.entries(yearData.quarters).map(([quarter, items]) => (
                <div key={quarter} className="roadmap-quarter">
                  <h3>{quarter}</h3>
                  <ul>
                    {items.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="choice-button-container">
          <button className="choice-button" onClick={() => navigate('/faq')}>
            Back to FAQ
          </button>
          <button className="choice-button" onClick={() => navigate('/characters')}>
            Forward to Characters
          </button>
        </div>
      </DigitalDisplay>
    </div>
  );
};

export default Roadmap;
